import React, { useRef, useState, useEffect } from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import { default as CheckBoxMUI } from "@mui/material/Checkbox";


function Checkbox({
  label,
  name,
  filtrosSeleccionados,
  setFiltrosSeleccionados,
  indeterminate = false,
  datosProcesados
}) {

  const handleChange = (event) => {

    if (name === "areaTodas" && event.target.checked === true) {
      // Marca todas las areas como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        areaTodas: true,
        areaEPO: true,
        areaINT: true,
        areaMDL: true,
        areaMHS: true,
        areaMLminus: true,
        areaML_: true,
        areaMLL: true,
        areaMLU: true,
        areaMML: true,
        areaNIV: true,
        areaSTA: true,
        areaSTO: true,
      });

    } else if (name === "areaTodas" && event.target.checked === false) {
      // Desmarca todas las areas
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        areaTodas: false,
        areaEPO: false,
        areaINT: false,
        areaMDL: false,
        areaMHS: false,
        areaMLminus: false,
        areaML_: false,
        areaMLL: false,
        areaMLU: false,
        areaMML: false,
        areaNIV: false,
        areaSTA: false,
        areaSTO: false,
      });

    } else if (name === "materialTodas" && event.target.checked === true) {
      // Marca todas los materiales como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        materialTodas: true,
        materialIncremental: true,
        materialMineral: true,
        materialSubincremental: true,
        materialTepetate: true,
      });

    } else if (name === "materialTodas" && event.target.checked === false) {
      // Desmarca todas las materiales
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        materialTodas: false,
        materialIncremental: false,
        materialMineral: false,
        materialSubincremental: false,
        materialTepetate: false,
      });


    } else if (name === "movimientoTodas" && event.target.checked === true) {
      // Marca todas los movimientos como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        movimientoTumbado: true,
        movimientoProduccion: true,
        movimientoTepetate: true,
        movimientoRemanejo: true,
        movimientoAlimentacion: true,
        movimientoMHS: true,
        movimientoBanda: true,
      });
    }

    else if (name === "movimientoTodas" && event.target.checked === false) {
      // Marca todas los movimientos como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        movimientoTumbado: false,
        movimientoProduccion: false,
        movimientoTepetate: false,
        movimientoRemanejo: false,
        movimientoAlimentacion: false,
        movimientoMHS: false,
        movimientoBanda: false,
      });
    }

    else if (name === "desarrolloTodas" && event.target.checked === true) {
      // Marca todas los movimientos como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        desarrolloTodas: true,
        desarrolloVertical: true,
        desarrolloLateral: true,
        desarrolloDesborde: true,
        desarrolloDescabece: true,
        desarrolloDespate: true,
        desarrolloEncapille: true,
        desarrolloMHS: true,
        desarrolloBL: true
      });
    }

    else if (name === "desarrolloTodas" && event.target.checked === false) {
      // Marca todas los movimientos como true
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        desarrolloTodas: false,
        desarrolloVertical: false,
        desarrolloLateral: false,
        desarrolloDesborde: false,
        desarrolloDescabece: false,
        desarrolloDespate: false,
        desarrolloEncapille: false,
        desarrolloMHS: false,
        desarrolloBL: false
      });
    }

    else {
      
      // Marca o desmarca solo el checkbox seleccionado
      setFiltrosSeleccionados({
        ...filtrosSeleccionados,
        [name]: event.target.checked,
      });
    }
  };

  const [visible, setVisible] = useState(true);
  const [datosTemp, setDatosTemp] = useState([])

  return (
    <div>
      <FormControlLabel
        control={
          <CheckBoxMUI
            checked={filtrosSeleccionados[name]}
            indeterminate={indeterminate}
            onChange={handleChange}
            color="amarrillo"
            sx={{
              color: "#fffcfc",
              "&.Mui-checked": {
                color: "#cb9636",
              },
            }}
          />
        }
        label={<span className="p-1 text-sm gap-x-2 text-blanco">{label}</span>}
      />
    </div>
  );
}

export default Checkbox;
